module.exports = {
  API: 'https://www.aistan.com.au/api',
  port: 3000
};
